import React from "react";
import Lottie from "react-lottie";
import * as animationData from "./Animation/LoginLottie.json";
import "../../Login/LoginPage/Animation/LoginLottie.css";

const LoginLottie = ({appSetup,IMG_URL}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      <section className="main-lottey">
        <div className="success mx-auto ">
          <div className="login-brand">
            {/* <img
              src={IMG_URL + appSetup.logo}
              className="logoimgg"
            /> */}
            <div className="login-brand__logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/images/opslogo.png"}
                alt="Frame Karigar"
              />
            </div>
            <h1 className="login-brand__title">
              Every frame, crafted with care.
            </h1>
            <p className="login-brand__text">
              Manage products, orders and customers for Frame Karigar from
              one elegant workspace.
            </p>
            <div className="login-brand__divider" aria-hidden="true"></div>
          </div>
        </div>
      </section>
      {/* <section className="main-lottey">
        <div className="success mx-auto">
          <Lottie options={defaultOptions} />
        </div>
      </section> */}
    </>
  );
};

export default LoginLottie;
